module.exports = {
  themeColor: '#409EFF',
  linnerColor:'#7D8AFF',
  themeColorOption: ['#FF4F6D', '#CDB476', '#9661FF', '#5ECAA9', '#FF8A36', '#2F74FF'],
  level_color_arr: ['#268EDE', '#22B7C7', '#14B775', '#FFCC28', '#FF9F45', '#FF6410', '#FF3758', '#4F3FD7', '#9A763A', '#D4AB65'],
}